import { createAction, props } from '@ngrx/store';

export const loadFirmaZeitenStart = createAction('MITARBEITERVERWALTUNG::LOAD_FIRMAZEITEN_START' );
export const loadFirmaZeitenSucceeded = createAction(
    'MITARBEITERVERWALTUNG::LOAD_FIRMAZEITEN_SUCCEEDED',
    props<{ item: any[] }>(),
);
export const loadFirmaZeitenFailed = createAction('MITARBEITERVERWALTUNG::FIRMAZEITEN_FAILED', props<{ error: Error }>());
